enum SecurityScoreNameEnum {
  VeryWeak = 'veryWeak',
  Weak = 'weak',
  Medium = 'medium',
  Strong = 'strong',
  VeryStrong = 'veryStrong',
}

export default SecurityScoreNameEnum;
